import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {VENDOR_NAMES} from '@/constants/billingConstants';

const state = {
  filterData: {
    accounts: [
      "045665193992"
    ],
    products: [
      {
        code: "AmazonEC2",
        name: "EC2",
        parentCode: "SP_PRODUCT",
        codes: null
      }
    ],
    regions: [
      {
        code: "ap-northeast-2",
        name: "Asia Pacific (Seoul)",
        parentCode: "RGNCONVERT",
        codes: null
      }
    ],
    instanceFamilies: [
      "m5"
    ]
  },
  coverageList: {
    totalCount: 0,
    list: [
      {
        coverageUtil: 0,
        savingsPlansUsageCoverage: 0.0,
        reservedUsageCoverage: 100.0,
        totalUsageCoverage: 100.0,
        savingsPlansCost: 0.0,
        reservedOnDemandCost: 160.704,
        onDemandCost: 0.0,
        totalCost: 0.0,
        onDemandUsage: 0.0,
        reservedUsage: 744.0,
        savingsPlanUsage: 0.0,
        totalUsage: 744.0,
        linkedAccountId: 384224417642,
        payerAccountId: 632721170710,
        productCode: "AmazonEC2",
        productName: "EC2",
        instanceFamily: "m5",
        regionCode: "ap-northeast-1",
        regionName: "Asia Pacific (Tokyo)"
      }
    ]
  },
  totalSummary: {
    coverageUtil: 16.16604203972143,
    savingsPlansUsageCoverage: 1.60188046180724,
    reservedUsageCoverage: 0.4704804106097,
    totalUsageCoverage: 2.07236087241694,
    savingsPlansCost: 22962.7311447999,
    reservedOnDemandCost: 71701.6230152371,
    onDemandCost: 119080.2691664599,
    totalCost: 142043.0003112598,
    onDemandUsage: 1.3725346916467103E8,
    reservedUsage: 659416.16795305,
    savingsPlanUsage: 2245164.4145500534,
    totalUsage: 1.4015804974717414E8
  },
  transition: [
    {
      coverageUtil: 15.32689092149637,
      savingsPlansUsageCoverage: 1.89776948354274,
      reservedUsageCoverage: 0.46183086623419,
      totalUsageCoverage: 2.35960034977693,
      savingsPlansCost: 746.6901012454,
      reservedOnDemandCost: 2283.480359424,
      onDemandCost: 4125.0748579359,
      totalCost: 4871.7649591813,
      onDemandUsage: 4474152.875370939,
      reservedUsage: 21162.366249,
      savingsPlanUsage: 86961.0409420789,
      totalUsage: 4582276.282562018,
      usageDate: "2020-08-01"
    }
  ],
  selectedVendor: VENDOR_NAMES.AWS,
  selectedViewByOption: '',
  isFilterLoading: true,
  isTotalSummaryLoading: true,
  isCoverageListLoading: true,
  isTransitionLoading: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/coverage/index.js